var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmojiInChat = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M8 16c4.411 0 8-3.589 8-8s-3.589-8-8-8-8 3.589-8 8 3.589 8 8 8m3.333-11.29c.736 0 1.334.598 1.334 1.333a1.335 1.335 0 0 1-2.667 0c0-.735.598-1.333 1.333-1.333m-6.666 0C5.402 4.71 6 5.308 6 6.043c0 .736-.598 1.334-1.333 1.334a1.335 1.335 0 0 1-1.334-1.334c0-.735.598-1.333 1.334-1.333M2.43 9.537a.5.5 0 0 1 .402-.204h10.334a.5.5 0 0 1 .477.648A5.89 5.89 0 0 1 8 14.147 5.885 5.885 0 0 1 2.356 9.98a.5.5 0 0 1 .075-.444"
})));
export default SvgEmojiInChat;